// src/pages/PaymentCallback.js
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const handlePaymentCallback = async () => {
      const reference = searchParams.get('reference');
      const status = searchParams.get('status');

      if (!reference || !status) {
        setError('Invalid payment parameters');
        localStorage.removeItem('paymentStatus');
        navigate('/checkout');
        return;
      }

      try {
        if (status === 'success') {
          const paidPlan = JSON.parse(localStorage.getItem('paidPlan'));

          if (!paidPlan?.features) {
            throw new Error('Invalid subscription plan');
          }

          // Store payment confirmation
          localStorage.setItem('paymentStatus', 'success');
          localStorage.setItem('reference', reference);

          // Handle navigation based on plan features
          const featureRoutes = {
            'Venting Room': '/venting-room-dashboard',
            'Entrepreneurship': '/entrepreneurship-dashboard',
            'STEM Subjects': '/stem-subjects-dashboard'
          };

          const targetRoute = paidPlan.features.find(feat => featureRoutes[feat])
            || '/checkout';

          navigate(targetRoute);
        } else {
          throw new Error('Payment verification failed');
        }
      } catch (error) {
        console.error('Payment processing error:', error);
        setError(error.message);
        localStorage.setItem('paymentStatus', 'failed');
        navigate('/checkout');
      } finally {
        setLoading(false);
      }
    };

    handlePaymentCallback();
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <div className="payment-processing">
        <h1>Processing Payment...</h1>
        <p>Please wait while we verify your transaction</p>
        <div className="loader"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="payment-error">
        <h1>Payment Processing Error</h1>
        <p>{error}</p>
        <button onClick={() => navigate('/checkout')}>
          Return to Checkout
        </button>
      </div>
    );
  }

  return null;
};

export default PaymentCallback;
